import { Button, Flex, Link, Text } from '@chakra-ui/react';
import React from 'react';
import { useSession } from 'shared-components/authentication';

interface IProps {
  onLogout: () => void;
  student_number: string;
  applyUrl?: string | null;
  hasApplyAccess?: boolean;
}

const Footer: React.FC<IProps> = props => {
  const { onLogout: onLogoutFromProps, student_number, applyUrl, hasApplyAccess } = props;

  const session = useSession();
  const onLogout = async () => {
    await session.onLogout(true);
    onLogoutFromProps();
  };

  return (
    <>
      <Flex display="flex" flexDirection="column" alignItems="center" justifyContent="center" mx={8} my={4}>
        <Text variant="allcaps" fontSize="sm" mb={2}>
          Student: {student_number}
        </Text>

        {applyUrl && hasApplyAccess && (
          <Button variant="ghost" as={Link} href={applyUrl} mb={2}>
            View in Apply
          </Button>
        )}

        <Button onClick={onLogout} variant="ghost">
          Log out
        </Button>
      </Flex>
    </>
  );
};

export default Footer;
